import { SignalRService, type NotificationData } from '~/core/services/signalRService';
import { useToast } from '~/composables/useToast';
import { useDataRefresh } from '~/composables/useDataRefresh';

export const useNotifications = () => {
  const isListening = ref(false);
  const { addToast } = useToast();

  // Khởi tạo listener cho notifications
  const startListening = () => {
    if (isListening.value) return;

    SignalRService.onReceiveNotification((notification: NotificationData) => {
      console.log('Received notification:', notification);
      
      // Hiển thị toast notification
      
      showToastNotification(notification);
      
      // Phát âm thanh thông báo (tùy chọn)
      //playNotificationSound();
    });

    isListening.value = true;
  };

  // Dừng listener
  const stopListening = () => {
    if (!isListening.value) return;
    
    SignalRService.offReceiveNotification();
    isListening.value = false;
  };


  // Hiển thị toast notification
  const showToastNotification = (notification: NotificationData) => {
    console.log('📢 [useNotifications] Received notification:', notification);
    
    // Nếu là notification về Student, set refresh state
    
      const { setNewDataNotification } = useDataRefresh('Student');
      setNewDataNotification(notification);

    // Xác định loại toast dựa trên nội dung notification
    let toastType: 'success' | 'error' | 'warning' | 'info' = 'info';
    
    // Có thể customize logic để xác định type dựa trên notification.objectType hoặc title
    if (notification.title?.toLowerCase().includes('thành công') || 
        notification.message?.toLowerCase().includes('thành công')) {
      toastType = 'success';
    } else if (notification.title?.toLowerCase().includes('lỗi') || 
               notification.message?.toLowerCase().includes('lỗi')) {
      toastType = 'error';
    } else if (notification.title?.toLowerCase().includes('cảnh báo') || 
               notification.message?.toLowerCase().includes('cảnh báo')) {
      toastType = 'warning';
    }

    // Thêm toast
    addToast(notification, {
      type: toastType,
      duration: 5000,
      autoClose: true
    });
  };

  // Phát âm thanh thông báo
  const playNotificationSound = () => {
    try {
      const audio = new Audio('/notification-sound.mp3'); // Thêm file âm thanh vào public
      audio.volume = 0.5;
      audio.play().catch(err => {
        console.log('Cannot play notification sound:', err);
      });
    } catch (error) {
      console.log('Notification sound not available');
    }
  };

  // Yêu cầu quyền notification
  const requestNotificationPermission = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
    return false;
  };

  // Cleanup khi component unmount
  onUnmounted(() => {
    stopListening();
  });

  return {
    isListening: readonly(isListening),
    startListening,
    stopListening,
    requestNotificationPermission
  };
}; 